module.exports = __webpack_public_path__ + "static/media/digilearn.0a6bb98f.png";